import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const srOnly = css`
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
`;

export const notSrOnly = css`
    width: auto;
    height: auto;
    margin: 0;
    clip: auto;
    white-space: normal;
    position: initial;
`;

export const Hiddenh2 = styled.h2`
    ${srOnly};
`;

export const Hiddenh3 = styled.h3`
    ${srOnly};
`;

export const HiddenSpan = styled.span`
    ${srOnly};
`;

export const mobileOnly = ({ theme }) => css`
    @media (min-width: ${theme.breakpoint.largeTablet}) {
        display: none;
    }
`;

export const calcVw = (width) => {
    return `calc(var(--vw, 1vw) * ${width})`;
};
